export default __webpack_public_path__ + "static/media/icon_views.70e66f30.svg";